import { render } from "./WaveLayout.vue?vue&type=template&id=3bf81eed"
import script from "./WaveLayout.vue?vue&type=script&lang=js"
export * from "./WaveLayout.vue?vue&type=script&lang=js"

import "./WaveLayout.vue?vue&type=style&index=0&id=3bf81eed&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__